module.exports = __webpack_public_path__ + "assets/img/6a1136569b6ef908177089ea97baa88f.png";